export default __webpack_public_path__ + "static/media/Van29.a387310a.webp";